import { NavLink } from "react-router-dom";
import { Link } from "react-scroll";
import classes from "./NavBar.module.css";
import NavBarContext from "../../store/navbar-context";
import { useContext, useEffect } from "react";

const NavBar = (props) => {
  const navCtx = useContext(NavBarContext);

  const homeHandler = () => {
    navCtx.show();

    setTimeout(() => {
      document.getElementById("main").scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const hideHandler = () => {
    navCtx.hide();
  };

  useEffect(() => {}, [navCtx.isShown]);

  return (
    <header className={classes.header}>
      <nav>
        <ul>
          <li>
            <NavLink
              activeClassName={classes.active}
              to="/ejs"
              onClick={homeHandler}
            >
              Home
            </NavLink>
          </li>
          {navCtx.isShown && (
            <li>
              <div className={classes.dropdown}>
                <button className={classes.dropDownBtn}>Countries</button>
                <div className={classes.dropdownContent}>
                  <Link activeClass={classes.active} to="poland" smooth={true}>
                    <p>Poland</p>
                  </Link>
                  <Link activeClass={classes.active} to="germany" smooth={true}>
                    <p>Germany</p>
                  </Link>
                  <Link activeClass={classes.active} to="croatia" smooth={true}>
                    <p>Croatia</p>
                  </Link>
                </div>
              </div>
            </li>
          )}
          <li>
            <div className={classes.dropdown}>
              <button className={classes.dropDownBtn}>More</button>
              <div className={classes.dropdownContent}>
                <NavLink
                  activeClassName={classes.active}
                  to="/gallery"
                  onClick={hideHandler}
                >
                  <p>Gallery</p>
                </NavLink>
                <NavLink
                  activeClassName={classes.active}
                  to="/materials"
                  onClick={hideHandler}
                >
                  <p>Results</p>
                </NavLink>
                <NavLink
                  activeClassName={classes.active}
                  to="/selfie"
                  onClick={hideHandler}
                >
                  <p>Selfie+</p>
                </NavLink>
              </div>
            </div>
          </li>
          {navCtx.isShown && (
            <li>
              <Link activeClass={classes.active} to="contact" smooth={true}>
                Contact
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
};

const NavBarGlob = (props) => {
  const navCtx = useContext(NavBarContext);

  const homeHandler = () => {
    navCtx.show();

    setTimeout(() => {
      document.getElementById("main").scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const hideHandler = () => {
    navCtx.hide();
  };

  useEffect(() => {}, [navCtx.isShown]);

  return (
    <header className={classes.header}>
      <nav>
        <ul>
          <li>
            <NavLink
              activeClassName={classes.active}
              to="/glob"
              onClick={homeHandler}
            >
              Start
            </NavLink>
          </li>
          <li>
            <NavLink
              activeClassName={classes.active}
              to="/products"
              onClick={hideHandler}
            >
              <p>Produkty</p>
            </NavLink>
          </li>
          {navCtx.isShown && (
            <li>
              <Link activeClass={classes.active} to="contact" smooth={true}>
                Kontakt
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
};

export { NavBar, NavBarGlob };
